<template>

    <Link as="div" :onStart="() => emits('navigate')" :href="props.list_item.seo_name ? route('productDetail.show', [props.list_item.seo_name]) : '#'" class="product-list-item">
        <div class="product-item">
            <div id="product_update_title" class="product-item-name title-s">{{ props.list_item.item_name }}</div>
            <p id="single_update" v-if="!isMultiple"  class="product-item-upd">Updated: {{ props.list_item.field_changed }}</p>
            <div v-else>
                <p class="product-item-upd">Updated: </p>
            <ul class="product-item-upd-list">
                <li v-for="(field, index) in fieldsChanged" :key="field" :id="`update_list_${index}`" class="product-item-upd">{{ field }}</li>
            </ul>
            </div>
            <p id="product_update_updated_at" class="product-item-upd">Updated: {{ useDateFormat(props.list_item.modified_date, 'MM/DD/YYYY') }}</p>
            
        </div>
    </Link> 
</template>
<script lang="ts" setup>
    import { computed, inject } from "vue";
    import { Link } from "@inertiajs/vue3";
    import { useDateFormat } from "@vueuse/core";
    let route = inject('route');
    let props = defineProps({
        list_item: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        }
    });
    let emits = defineEmits(['navigate']);
    let fieldsChanged = computed(() => {
        if(props.list_item.field_changed == null){
            return [];
        }
        return props.list_item.field_changed.split(",");
    });
    let isMultiple = computed(() => {
        return fieldsChanged.value.length > 1;
    });
</script>
